









































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AlpacaBtn from "@/components/AlpacaBtn.vue";
import { EventBus } from "@/utils/EventBus";
import BigNumber from "bignumber.js";
import { farmCardInfo } from "@/utils/farm";
import {
  LPBalanceOf,
  LPAllowance,
  LPIncreaseAllowance,
  LPUserInfo,
  pendingAlpa,
  deposit,
  withdraw,
  emergencyWithdraw,
  claim,
} from "@/utils/web3";

@Component({
  components: {
    AlpacaBtn,
  },
})
export default class FarmCard extends Vue {
  @Prop({
    required: true,
    default: 1,
    type: Number,
  })
  public pool!: 0 | 1 | 2;
  @Prop({
    required: true,
    default: false,
    type: Boolean,
  })
  public isOutdated!: boolean;

  public depositNum: string = "0";
  public withdrawNum: string = "0";
  public showWithdraw: boolean = false;
  public walletBalance: BigNumber = new BigNumber(0);
  public LPAllowance: BigNumber = new BigNumber(0);
  public LPUserInfoBalance: BigNumber = new BigNumber(0);
  public claimBalance: BigNumber = new BigNumber(0);
  public approveLoading: boolean = false;
  public farmInfo: any = null;

  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }

  get account() {
    return this.$store.getters.getAccount;
  }

  get showApprove() {
    return this.LPAllowance.isLessThan(new BigNumber(this.depositNum));
  }

  get totalDeposit() {
    if (!this.farmInfo) {
      return "--";
    }
    return this.$options.filters!.numberToBMK(this.farmInfo.totalDeposit);
  }

  get totalApy() {
    if (!this.farmInfo) {
      return "--";
    }
    return this.$options.filters!.fixedAndComma(this.farmInfo.totalApy);
  }

  get midApy() {
    if (!this.farmInfo || this.farmInfo.midApy.isEqualTo(0)) {
      return "--";
    }
    return this.$options.filters!.fixedAndComma(this.farmInfo.midApy);
  }

  get maxApy() {
    if (!this.farmInfo || this.farmInfo.maxApy.isEqualTo(0)) {
      return "--";
    }
    return this.$options.filters!.fixedAndComma(this.farmInfo.maxApy);
  }

  get userApy() {
    if (
      !this.farmInfo ||
      this.farmInfo.userApy.isEqualTo(0) ||
      this.LPUserInfoBalance.isEqualTo(0)
    ) {
      return "--";
    }
    return this.$options.filters!.fixedAndComma(this.farmInfo.userApy);
  }

  public mounted() {
    this.getBalance();
    this.getAllowance();
    this.getLPUserInfo();
    this.getPendingAlpa();
    this.getFarmCardInfo();
    EventBus.$on(`LP-approve-status`, this.onApproveStatus);
  }

  public async onApproveStatus(status: "completed" | "error") {
    if (status === "completed") {
      await this.getAllowance();
      this.approveLoading = false;
    }
    if (status === "error") {
      this.approveLoading = false;
    }
  }

  public depositChange() {
    if (this.depositNum === "") {
      return;
    } else if (new BigNumber(this.depositNum).isLessThan(0)) {
      this.depositNum = "0";
    } else if (
      new BigNumber(this.depositNum).isGreaterThan(this.walletBalance)
    ) {
      this.depositNum = this.walletBalance.toString();
    }
  }

  public withdrawChange() {
    if (this.withdrawNum === "") {
      return;
    } else if (new BigNumber(this.withdrawNum).isLessThan(0)) {
      this.withdrawNum = "0";
    } else if (
      new BigNumber(this.withdrawNum).isGreaterThan(this.LPUserInfoBalance)
    ) {
      this.withdrawNum = this.LPUserInfoBalance.toString();
    }
  }

  public async getBalance() {
    const amount = new BigNumber(await LPBalanceOf(this.account, this.pool));
    if (amount) {
      this.walletBalance = amount;
    }
  }

  public async getAllowance() {
    const amount = new BigNumber(await LPAllowance(this.account, this.pool));
    if (amount) {
      this.LPAllowance = amount;
    }
  }

  public async getLPUserInfo() {
    const res = await LPUserInfo(this.account, this.pool);
    if (res) {
      this.LPUserInfoBalance = new BigNumber(res.amount);
    }
  }

  public async getPendingAlpa() {
    const res = await pendingAlpa(this.account, this.pool);
    if (res) {
      this.claimBalance = new BigNumber(res);
    }
  }

  public async getFarmCardInfo() {
    const res = await farmCardInfo(this.account, this.pool);
    if (res) {
      this.farmInfo = res;
    }
  }

  public handleApprove() {
    this.approveLoading = true;
    LPIncreaseAllowance(this.account, 10000000, this.pool);
  }

  public handleClaim() {
    claim(this.account, this.pool);
  }

  public handleDeposit() {
    deposit(new BigNumber(this.depositNum), this.account, this.pool);
  }

  public handleWithdraw() {
    withdraw(new BigNumber(this.withdrawNum), this.account, this.pool);
    this.showWithdraw = false;
    this.withdrawNum = "0";
  }

  public maxDeposit() {
    this.depositNum = this.walletBalance.toString();
  }

  public maxWithdraw() {
    this.withdrawNum = this.LPUserInfoBalance.toString();
  }
}
